export function handleBurger() {
  const burgerItems = document.querySelectorAll(".burger");
  const menu = document.querySelector(".header__bottom");
  const headerTop = document.querySelector(".header__top");
  const menuLinks = document.querySelectorAll(".header__link");
  const body = document.querySelector(".body");

  if (!(menu && headerTop && body && menuLinks.length)) return;

  burgerItems.length &&
    burgerItems.forEach(burgerItem => {
      burgerItem.addEventListener("click", () => {
        burgerItem.classList.toggle("active");
        menu.classList.toggle("header__bottom_burger");
        headerTop.classList.toggle("header__top_burger");
        body.classList.toggle("body_lock");
      });

      {
        if (window.innerWidth <= 1100) {
          for (let i = 0; i < menuLinks.length; i += 1) {
            menuLinks[i].addEventListener("click", () => {
              burgerItem.classList.remove("active");
              menu.classList.remove("header__bottom_burger");
              headerTop.classList.remove("header__top_burger");
              body.classList.remove("body_lock");
            });
          }
        }
      }
    });

  window.addEventListener("resize", () => {
    if (window.innerWidth > 1100) {
      // Сбрасываем классы и стили, связанные с бургер-меню
      burgerItems.forEach(burgerItem => burgerItem.classList.remove("active"));
      menu.classList.remove("header__bottom_burger");
      headerTop.classList.remove("header__top_burger");
      body.classList.remove("body_lock");
    }
  });
}
